<!--参考模板-->
<template>
	<div class="temp-selected-refer" v-show="tempReferRectList.length > 0">
		<div class="operate-area">
			参考模板:
			<div class="img-wrap" v-for="(item, index) in tempReferRectList" :key="item.image">
				<i class="iconfont iconguanbi" @click="delRefer(index)"></i>
				<img :src="item.image" />
			</div>
			<div class="clear" @click="clearTemp">清空模板</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
	name: 'temp-selected-refer',
	computed: { ...mapGetters('examination/configation', ['tabActive', 'tempReferRectList']) },
	methods: {
		...mapActions('examination/databases', ['set', 'get', 'del']),
		...mapMutations('examination/configation', ['setTempReferRectList']),
		// 删除参考模板
		delRefer(index) {
			this.$delete(this.tempReferRectList, index)
			this.setTempReferRectList(this.tempReferRectList)
		},
		//清空模板
		clearTemp() {
			this.setTempReferRectList([])
		}
	}
}
</script>

<style scoped lang="less">
.temp-selected-refer {
	width: 100%;
	position: absolute;
	bottom: 30px;
	.operate-area {
		color: #c2c2c2;
		text-align: center;
		.img-wrap {
			position: relative;
			&:hover .iconfont {
				display: block;
			}
			.iconfont {
				position: absolute;
				top: 10px;
				right: 10px;
				color: black;
				font-size: 16px;
				display: none;
			}
			img {
				max-width: 100%;
			}
		}
		.clear {
			width: 70px;
			border-radius: 5px;
			background: #01524b;
			margin-left: 10px;
			font-size: 14px;
			padding-bottom: 2px;
			color: white;
			&:hover {
				cursor: pointer;
			}
		}
	}
}
</style>
